<template>
    <modal ref="modal" @hidden="$emit('hidden')" :size="size">
        <h4 slot="modal-title">
            <i v-if="icon" :class="icon"></i> {{title}}
        </h4>
        <div slot="modal-body">
            <slot name="body">
                <p>
                    {{body}}
                </p>    
            </slot>
        </div>
        <div class="row align-content-end" slot="modal-footer">
            <div v-for="button in buttons" :key="`${button.name}-${guid()}`" class="col-auto d-flex flex-column">
                 <button class="mt-auto" :class="button.class || ''" @click="emitChoice(button.emit)">
                     <i v-if="button.icon" :class="button.icon"></i> {{button.name || ''}}
                 </button>
            </div>
        </div>
    </modal>
</template>

<script>

import guid from '../../Util/Mixins/guid';
import Modal, {sizes} from './Modal.vue'
import resources from "@core/Util/resources";

const buttonType = {
        Yes: {
            get name() { return resources('Button_Yes');  },
            class: 'btn btn-primary btn-sm',
            emit: 'yes'
        },
        No: {
            get name() { return resources('Button_No');  },
            class: 'btn btn-secondary btn-sm',
            emit: 'no'
        },
        Ok: {
            get name() { return resources('Button_OK');  },
            class: 'btn btn-primary btn-sm',
            emit: 'ok'
        },
        Cancel: {
            get name() { return resources('Button_Cancel');  },
            class: 'btn btn-secondary btn-sm',
            emit: 'cancel',
            icon: 'fa fa-ban'
        },
        Close: {
            get name() { return resources('Button_Close');  },
            class: 'btn btn-secondary btn-sm',
            emit: 'close',
            icon: 'fa fa-cross'
        },
    };

export {
    buttonType,
    sizes
}

export default {
    name: 'prompt',
    mixins: [guid],
    components: {
        Modal
    },
    mounted() {
        this.$refs.modal.show();
    },
    methods: {
        emitChoice(event) {
            this.$refs.modal.hide();
            
            if(event) {
                this.$emit(event);
            }
        }
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        body: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        },
        buttons: {
            type: Array,
            default: () => {
                return [ 
                    buttonType.No, 
                    buttonType.Yes
                ]
            },
            validate: v => {
                return typeof v === 'array' && v !== null;
            }
        },
        size: {
                type: String,
                default: sizes.small,
                validate: v => {
                    return v === "" || Object.values(sizes).indexOf(v) !== -1
                }
            }
    }
};
</script>

<style lang="scss" scoped>
.col-auto {
    padding-left: 0;
}

::v-deep .modal-content {
    border:  1px solid #ccc;
    border-radius: 5px;
    top: 10px;
}

::v-deep .modal-header {
    padding: 5px;
    padding-left: 12px;
    height: 33px;
}
    
::v-deep .modal-footer {
    padding: 6px;
}
</style>